import { createUserManager } from 'redux-oidc'
import { LANDINGPAGE } from './constants'

const userManagerConfig = {
  client_id: `${process.env.CLIENT_ID}`,
  redirect_uri: `${process.env.APP_BASE_URL}/#/${LANDINGPAGE}/callback`,
  response_type: 'token id_token',
  scope: 'openid profile MLexApp MLexUser',
  authority: `${process.env.IDENTITY_BASE_URL}`,
  silent_redirect_uri: `${process.env.APP_BASE_URL}/silentRenew.html`,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true
}

const userManager = createUserManager(userManagerConfig)

export default userManager
